export default "__VITE_ASSET__9ComhH1E__"